import type { WidgetStyle } from '@/lib/chat-interface/widget-styles';

export type SuggestedChipSurface = 'light' | 'dark';

export function chipSurfaceFromWidget(
  widgetStyle?: WidgetStyle | string,
  theme?: 'light' | 'dark'
): SuggestedChipSurface {
  if (widgetStyle === 'black') return 'dark';
  // Glass sits on an unknown host page. White-on-translucent reads as
  // blank pills on light dashboards and embeds — always use a solid light chip.
  if (widgetStyle === 'glass') return 'light';
  if (theme === 'dark') return 'dark';
  return 'light';
}

export function suggestedQuestionChipColors(surface: SuggestedChipSurface) {
  if (surface === 'dark') {
    return {
      bg: '#2a2a2a',
      hover: '#3f3f3f',
      text: '#f5f5f5',
    };
  }
  return {
    bg: '#e8e8ea',
    hover: '#d4d4d8',
    text: '#18181b',
  };
}
